var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var FULL_SCREEN_STYLE = {
    position: 'absolute',
    left: '-16px',
    right: '-16px',
    top: '12px',
};
/**
 * This component is used to add basic styling for its child components
 */
var ContentFrame = function (_a) {
    var children = _a.children, testid = _a["data-testid"], fullScreenContents = _a.fullScreenContents, padding = _a.padding;
    return (React.createElement("div", { "data-name": "ContentFrameFrame", "data-testid": testid || 'ContentFrame', style: __assign({ display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box', overflowY: 'auto', padding: padding || '0 24px 24px' }, (fullScreenContents ? FULL_SCREEN_STYLE : {})) }, children));
};
export default ContentFrame;
